import React, { Component } from 'react';
import Header from './componentes/Header';
import Formulario from './componentes/Formulario';
import Error from './componentes/Error';
import Clima from './componentes/Clima';

class App extends Component {

  state = {
    error: '',
    consulta : {},
    resultado : {}
  }

  componentDidMount() {
    this.setState({
      error: false
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.consulta !== this.state.consulta){
      this.consultarApi();
    }
  }

  //consultar APi
  consultarApi = () => {
    const {ciudad, pais} = this.state.consulta;
    //para que no imprima undefined
    if(!ciudad || !pais) return null;
    //leer la url y agregar el API key    
    const appId = 'e3097b9b6be9b7d083f750aed9586c86';
    let url = `https://api.openweathermap.org/data/2.5/weather?q=${ciudad},${pais}&appid=${appId}`;
    //query con fetch api
    //consultar con fetch
    fetch(url)
      .then(respuesta => {
        return respuesta.json();
      })
      .then(datos => {
        //console.log(datos);

        this.setState({
          resultado : datos
        })
      })
      .catch(error => {
        console.log(error);
      })
  }

  datosConsulta = respuesta => {
    if(respuesta.ciudad === '' || respuesta.pais === '')
    {
      this.setState({
        error: true
      })
    }
    else{
      this.setState({
        consulta : respuesta,
        error : false
      })
    }
  }

  render() {

    const {error} = this.state,
          {cod} = this.state.resultado;

    let resultado;
    
    if(error)
    {
      resultado = <Error mensaje="Ambos campos son obligatorios" />
    }
    else if(cod === "404"){
      resultado = <Error mensaje="Ciudad no encontrada" />
    }
    else
    {
      resultado = <Clima resultado = {this.state.resultado}/>
    }

    return (
      <div className="App">
        <Header 
          titulo = "Clima React"
        />

        <Formulario
          datosConsulta = {this.datosConsulta}
         />
         {resultado}
      </div>
    );
  }
}

export default App;
